// extracted by mini-css-extract-plugin
export default {"title":"title__uck5A","message":"message__PpqMh","visible":"visible__+xK9Q","actions":"actions__eer7X"};